module.exports = global["BVMetas"] = require("-!/export/apps/mobile/node_modules/babel-loader/lib/index.js??ref--12-0!./metas.js");